import { sensorLiveDataConstants } from "../../constants/client";

export const sensorLiveData = {
  liveData,
  liveDataSuccess,
  liveDataFailure,
};

function liveData(payload) {
  return { type: sensorLiveDataConstants.LIVE_DATA_REQUEST,  payload };
}

function liveDataSuccess(payload) {
  return { type: sensorLiveDataConstants.LIVE_DATA_SUCCESS, payload };
}

function liveDataFailure(error) {
  return { type: sensorLiveDataConstants.LIVE_DATA_FAILURE, error };
}